import * as React from "react";
import { Box, IconButton } from "@mui/material";
import { ExpandMore, ExpandLess } from "@mui/icons-material";
import { useTheme } from "@mui/material/styles";
import { usePageLayout } from "../GeneralLayout";

interface BottomDrawerProps {
  drawerContent: React.ReactNode;
  height?: number;
  leftOffset?: number;
  rightOffset?: number;
}

export default function BottomDrawer({
  drawerContent,
  height = 200,
  leftOffset = 0,
  rightOffset = 0,
}: BottomDrawerProps) {
  const theme = useTheme();
  const { openBottom, toggleBottom } = usePageLayout();

  return (
    <Box
      sx={{
        position: "absolute",
        bottom: 0,
        left: leftOffset,
        right: rightOffset,
        height: openBottom ? `${height}px` : "50px",
        bgcolor: theme.custom.ui.drawers.bottom.dark,
        color: theme.custom.base.text.primary.dark,
        transition: "all 0.3s ease",
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
        zIndex: 5,
        boxShadow: 2,
      }}
    >
      <IconButton
        onClick={toggleBottom}
        sx={{
          alignSelf: "center",
          color: theme.custom.base.text.primary.dark,
          mt: 0.5,
        }}
      >
        {openBottom ? <ExpandMore /> : <ExpandLess />}
      </IconButton>
      {openBottom && <Box sx={{ flex: 1, p: 2, overflowY: "auto" }}>{drawerContent}</Box>}
    </Box>
  );
}
